function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import SvgPlusChunky from '../../iconography/icons/PlusChunky';
import Icon from '../../icon/Icon';
import Button from '../../button/Button';
import { STYLE_LINK, TYPE_SUBMIT, SIZE_BLOCK } from '../../button/constants';
import Divider from '../../divider/Divider';
import InputField from '../../inputField/InputField';
import CheckboxGroup from '../../checkboxGroup/CheckboxGroup';
import Checkbox from '../../checkbox/Checkbox'; // eslint-disable-next-line react/no-multi-comp

export var AddToCollectionView =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(AddToCollectionView, _PureComponent);

  function AddToCollectionView() {
    _classCallCheck(this, AddToCollectionView);

    return _possibleConstructorReturn(this, _getPrototypeOf(AddToCollectionView).apply(this, arguments));
  }

  _createClass(AddToCollectionView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          userCollections = _this$props.userCollections,
          eventCollections = _this$props.eventCollections,
          isSmallScreen = _this$props.isSmallScreen,
          onAddOrRemoveEventToCollection = _this$props.onAddOrRemoveEventToCollection,
          onCloseDropdown = _this$props.onCloseDropdown,
          onShowCreateCollection = _this$props.onShowCreateCollection,
          savedByYou = _this$props.savedByYou,
          onSaveEvent = _this$props.onSaveEvent,
          eventId = _this$props.eventId;
      var checkboxContainerClassnames = classNames('add-to-collection__main', 'eds-l-mar-hor-6', {
        'add-to-collection__main--desktop eds-l-pad-bot-2': !isSmallScreen,
        'eds-l-pad-bot-8': isSmallScreen
      });
      var bottomButtonContainerClassName = classNames({
        'eds-align--center eds-l-mar-top-2': !isSmallScreen,
        'collection-button__smallscreen eds-l-pad-all-4': isSmallScreen
      });
      return React.createElement("div", {
        className: "add-to-collection"
      }, React.createElement("div", {
        className: "eds-l-pad-left-2 eds-l-pad-bot-1"
      }, React.createElement(Button, {
        style: STYLE_LINK,
        onClick: onShowCreateCollection
      }, React.createElement(Icon, {
        type: React.createElement(SvgPlusChunky, null),
        color: "ui-blue"
      }), gettext('New collection'))), React.createElement("div", {
        className: checkboxContainerClassnames
      }, React.createElement(Checkbox, {
        value: savedByYou,
        id: "liked-checkbox",
        onChange: onSaveEvent.bind(null, eventId)
      }, gettext('Likes')), React.createElement(CheckboxGroup, {
        values: userCollections.map(function (_ref) {
          var name = _ref.name,
              id = _ref.id;
          return {
            display: name,
            value: id
          };
        }),
        value: eventCollections,
        name: "user-collection-group",
        onChange: onAddOrRemoveEventToCollection
      })), React.createElement("div", {
        className: "eds-show-up-md"
      }, React.createElement(Divider, null)), React.createElement("div", {
        className: bottomButtonContainerClassName
      }, React.createElement(Button, {
        style: STYLE_LINK,
        size: SIZE_BLOCK,
        onClick: onCloseDropdown
      }, gettext('Done'))));
    }
  }]);

  return AddToCollectionView;
}(PureComponent); // eslint-disable-next-line react/no-multi-comp

_defineProperty(AddToCollectionView, "propTypes", {
  onSaveEvent: PropTypes.func.isRequired,
  userCollections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
    href: PropTypes.string,
    eventCount: PropTypes.number
  })).isRequired,
  eventCollections: PropTypes.arrayOf(PropTypes.string),
  isSmallScreen: PropTypes.bool,
  onAddOrRemoveEventToCollection: PropTypes.func,
  onCloseDropdown: PropTypes.func,
  onShowCreateCollection: PropTypes.func,
  savedByYou: PropTypes.bool,
  eventId: PropTypes.string
});

export var CreateCollectionView =
/*#__PURE__*/
function (_PureComponent2) {
  _inherits(CreateCollectionView, _PureComponent2);

  function CreateCollectionView() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CreateCollectionView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CreateCollectionView)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      inputValue: '',
      errorNote: ''
    });

    _defineProperty(_assertThisInitialized(_this), "_handleInputChange", function (val) {
      _this.setState({
        inputValue: val
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSubmit", function (e) {
      var onCreateCollection = _this.props.onCreateCollection;
      e.preventDefault();

      if (_this.state.inputValue) {
        onCreateCollection(_this.state.inputValue);
      } else {
        _this.setState({
          errorNote: gettext('Name is required')
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleFocus", function () {
      _this.setState({
        errorNote: ''
      });
    });

    return _this;
  }

  _createClass(CreateCollectionView, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          inputValue = _this$state.inputValue,
          errorNote = _this$state.errorNote;
      var isSmallScreen = this.props.isSmallScreen;
      var bottomButtonContainerClassName = classNames('eds-align--center eds-l-mar-top-6 eds-l-mar-bot-4', {
        'collection-button__smallscreen eds-l-mar-hor-4': isSmallScreen
      });
      return React.createElement("form", {
        onSubmit: this._handleSubmit,
        className: "eds-l-pad-hor-4"
      }, React.createElement(InputField, {
        id: "collection-name",
        onChange: this._handleInputChange,
        onFocus: this._handleFocus,
        value: inputValue,
        label: gettext('Name'),
        placeholder: gettext('e.g. "New Years Parties"'),
        required: true,
        hasError: !!errorNote,
        annotationNote: errorNote
      }), React.createElement("div", {
        className: bottomButtonContainerClassName
      }, React.createElement(Button, {
        style: STYLE_LINK,
        type: TYPE_SUBMIT,
        size: SIZE_BLOCK
      }, gettext('Create'))));
    }
  }]);

  return CreateCollectionView;
}(PureComponent);
/*
Container view to be passed into the
dropdown/modal in the eventcard
logic when the icon is clicked.

The view will manage the state to
 control when to show/hide create
 flow vs add or remove flow
*/
// eslint-disable-next-line react/no-multi-comp

_defineProperty(CreateCollectionView, "propTypes", {
  onCreateCollection: PropTypes.func.isRequired,
  isSmallScreen: PropTypes.bool
});

var CollectionView =
/*#__PURE__*/
function (_PureComponent3) {
  _inherits(CollectionView, _PureComponent3);

  function CollectionView() {
    var _getPrototypeOf3;

    var _this2;

    _classCallCheck(this, CollectionView);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(CollectionView)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this2), "state", {
      isCreateCollectionView: false
    });

    _defineProperty(_assertThisInitialized(_this2), "_handleAddOrRemove", function (arrayOfCheckedOptions, _ref2) {
      var isChecked = _ref2.isChecked,
          value = _ref2.value;
      var _this2$props = _this2.props,
          onAddOrRemoveEventToCollection = _this2$props.onAddOrRemoveEventToCollection,
          eventId = _this2$props.eventId;
      onAddOrRemoveEventToCollection({
        eventId: eventId,
        isChecked: isChecked,
        value: value
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "_handleCreateCollection", function (name) {
      var _this2$props2 = _this2.props,
          eventId = _this2$props2.eventId,
          onCreateCollection = _this2$props2.onCreateCollection;
      onCreateCollection(name, [eventId]);

      _this2.setState({
        isCreateCollectionView: false
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "_handleShowCreateCollection", function () {
      var onShowCreateCollectionView = _this2.props.onShowCreateCollectionView;

      _this2.setState({
        isCreateCollectionView: true
      }, function () {
        if (onShowCreateCollectionView) {
          onShowCreateCollectionView();
        }
      });
    });

    return _this2;
  }

  _createClass(CollectionView, [{
    key: "render",
    // Container view to be passed into the modal
    // in the eventcard logic when the icon
    // is clicked. Will likely need to merge with
    // fiona's work once EB-103695 concludes
    value: function render() {
      var _this$props2 = this.props,
          eventCollections = _this$props2.eventCollections,
          userCollections = _this$props2.userCollections,
          savedByYou = _this$props2.savedByYou,
          eventId = _this$props2.eventId,
          isSmallScreen = _this$props2.isSmallScreen,
          onCloseDropdown = _this$props2.onCloseDropdown,
          onSaveEvent = _this$props2.onSaveEvent;
      var isCreateCollectionView = this.state.isCreateCollectionView;
      var containerClasses = classNames('eds-l-mar-top-6 eds-l-mar-bot-2', {
        'collection-view collection-view--dropdown': !isSmallScreen
      });
      var headerClasses = classNames('eds-align--center', {
        'eds-text-bl eds-text-weight--heavy': !isSmallScreen,
        'eds-text-hs': isSmallScreen
      });
      var content = React.createElement(AddToCollectionView, {
        eventCollections: eventCollections,
        userCollections: userCollections,
        onAddOrRemoveEventToCollection: this._handleAddOrRemove,
        onShowCreateCollection: this._handleShowCreateCollection,
        savedByYou: savedByYou,
        onSaveEvent: onSaveEvent,
        onCloseDropdown: onCloseDropdown,
        eventId: eventId,
        isSmallScreen: isSmallScreen
      });
      var title = gettext('Add to collection');
      var subtitle = null;

      if (isEmpty(userCollections)) {
        title = gettext('Add event to a collection');
        subtitle = React.createElement("div", {
          className: "add-to-collection__subtitle eds-text--center eds-text-bs eds-l-mar-top-2"
        }, gettext('Make plans, share them with friends, and always know what you\'re doing next'));
      }

      if (isCreateCollectionView) {
        title = gettext('Create a new collection');
        subtitle = null;
        content = React.createElement(CreateCollectionView, {
          isSmallScreen: isSmallScreen,
          onCreateCollection: this._handleCreateCollection
        });
      }

      return React.createElement("div", {
        className: containerClasses
      }, React.createElement("header", {
        className: "collection-view__header eds-l-pad-bot-2 eds-l-pad-hor-2"
      }, React.createElement("h2", {
        className: headerClasses
      }, title), subtitle), content);
    }
  }]);

  return CollectionView;
}(PureComponent);

_defineProperty(CollectionView, "propTypes", {
  userCollections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
    href: PropTypes.string,
    eventCount: PropTypes.number
  })).isRequired,
  isSmallScreen: PropTypes.bool,
  onCreateCollection: PropTypes.func.isRequired,
  onAddOrRemoveEventToCollection: PropTypes.func.isRequired,
  onCloseDropdown: PropTypes.func,
  onSaveEvent: PropTypes.func.isRequired,
  eventId: PropTypes.string,
  eventCollections: PropTypes.arrayOf(PropTypes.string),
  savedByYou: PropTypes.bool,
  onShowCreateCollectionView: PropTypes.func
});

_defineProperty(CollectionView, "defaultProps", {
  eventCollections: []
});

export { CollectionView as default };